import { Route, Routes } from 'react-router-dom';
import Home3Page from '../app/components/home/index3';
import AboutUsPage from '../app/components/misc/about-us';
import ContactPage from '../app/components/misc/contact-us';
import Error404Page from '../app/components/misc/error404';
import DiamondsPage from '../app/components/industries/diamonds';
import MetalsPage from '../app/components/industries/metals';
import NotesPage from '../app/components/industries/notes';
import ServicesDetailPage from '../app/components/services/services-detail';
import ElectronicsPage from '../app/components/industries/electronics';
import ArtPage from '../app/components/industries/arts';
import GlobalServices from '../app/components/services/GlobalServices';
import TrackingPage from '../app/components/misc/tracking';
import Storage from '../app/components/services/Storage';

function AppRoutes() {
  return (
    <Routes>
      <Route path='/' element={<Home3Page />} />

      <Route path='/about-us' element={<AboutUsPage />} />
      <Route path='/error404' element={<Error404Page />} />
      <Route path='/services/global-services/*' element={<GlobalServices />} />
      <Route path='/services/storage' element={<Storage />} />
      <Route path='/services/*' element={<GlobalServices />} />
      <Route
        path='/industries/diamonds-and-jewelry'
        element={<DiamondsPage />}
      />
      <Route path='/industries/precious-metals' element={<MetalsPage />} />
      <Route path='/industries/bank-notes' element={<NotesPage />} />
      <Route path='/industries/electronics' element={<ElectronicsPage />} />
      <Route path='/industries/fine-arts' element={<ArtPage />} />
      <Route path='/services/detail' element={<ServicesDetailPage />} />
      <Route path='/track-shipment' element={<TrackingPage />} />
      <Route path='/contact-us' element={<ContactPage />} />
      <Route path='*' element={<Error404Page />} />
      <Route element={<Error404Page />} />
    </Routes>
  );
}

export default AppRoutes;
